import { render, staticRenderFns } from "./contact-relations.vue?vue&type=template&id=5433444e&scoped=true&"
import script from "./contact-relations.ts?vue&type=script&lang=ts&"
export * from "./contact-relations.ts?vue&type=script&lang=ts&"
import style0 from "./contact-relations.scss?vue&type=style&index=0&id=5433444e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5433444e",
  null
  
)

export default component.exports